/* ログ一覧検索コントロール */
import React from 'react';
import DateTimePicker from './DateTimePicker';
import { inputAssistDigit } from '../Convert';

type Props = {
  options:
    | {
        error_level: KeyValue[];
        reception_sub_cd: KeyValue[];
      }
    | undefined;
  // 検索パラメータの型を定義する
  search_params: {
    created_at_from_ymd: string;
    created_at_from_hour: string;
    created_at_from_minute: string;
    created_at_to_ymd: string;
    created_at_to_hour: string;
    created_at_to_minute: string;
    error_level: string;
    message_code: string;
    message: string;
    reception_cd: string;
    reception_sub_cd: string;
    operation: string;
    src_address: string;
  };
  handleClickSearch: () => void;
  handleChangeSearchParams: (target: string | string[], param: string | Date) => void;
  is_connecting: boolean;
  message?: KeyMessage[];
  help_msg?: KeyMessage[];
};

type KeyValue = {
  key: string;
  value: string;
};
type KeyMessage = {
  key: string;
  message: string;
};
const LogSearchForm: React.FC<Props> = ({
  options,
  search_params,
  handleClickSearch,
  handleChangeSearchParams,
  message,
}) => {
  /**
   * 時間From
   * @param Date value フォームで入力された文字列
   */
  const handleChangeCreatedAt = (value: Date) => {
    if (isEmpty(search_params.created_at_to_ymd)) {
      handleChangeSearchParams(['created_at_from_ymd', 'created_at_to_ymd'], value);
    } else {
      handleChangeSearchParams('created_at_from_ymd', value);
    }
  };

  /**
   * empty判定
   * @param string value 入力値
   */
  const isEmpty = (value: string) => {
    return value === null || typeof value === 'undefined' || value.length === 0;
  };

  /**
   * バリデーションメッセージを取得する
   * @param keys 取得キー
   * @returns バリデーションメッセージ
   */
  const getMessage = (keys: string[]): string => {
    // バリデーションメッセージ取得
    const msg_list: string[] = [];
    keys.map((key) => {
      message?.map((msg) => {
        if (msg.key === key) {
          msg_list.push(msg.message);
        }
      });
    });
    // 重複を除去した配列を返す
    const msg_list_dupl = msg_list.filter(function (x, i, self) {
      return self.indexOf(x) === i;
    });

    // 配列内のメッセージを結合した値を返却
    return msg_list_dupl.join('\n');
  };

  return (
    <div id="search">
      <div className="search-area">
        <div className="search-container">
          <div className="row my-2">
            <div className="col-md-8 col-sm-16">
              <span className="search-criteria-head">時間</span>
              <DateTimePicker
                id="created-at-from"
                handleChangeDate={(date: Date) => handleChangeCreatedAt(date)}
                selected_ymd={
                  search_params.created_at_from_ymd.length > 0
                    ? new Date(search_params.created_at_from_ymd)
                    : null
                }
                selected_hour={
                  search_params.created_at_from_hour.length > 0
                    ? search_params.created_at_from_hour
                    : ''
                }
                selected_minute={
                  search_params.created_at_from_minute.length > 0
                    ? search_params.created_at_from_minute
                    : ''
                }
                message={getMessage([
                  'created_at_from_ymd',
                  'created_at_from_hour',
                  'created_at_from_minute',
                ])}
                help_msg={''}
                customInput={<input type="text" className="search-form-input" />}
                handleChangeHour={(hour: string) =>
                  handleChangeSearchParams('created_at_from_hour', hour)
                }
                handleChangeMinute={(minute: string) =>
                  handleChangeSearchParams('created_at_from_minute', minute)
                }
              />
              <span className="search-criteria-head-small">～</span>
              <DateTimePicker
                id="created-at-to"
                handleChangeDate={(date: Date) =>
                  handleChangeSearchParams('created_at_to_ymd', date)
                }
                selected_ymd={
                  search_params.created_at_to_ymd.length > 0
                    ? new Date(search_params.created_at_to_ymd)
                    : null
                }
                selected_hour={
                  search_params.created_at_to_hour.length > 0
                    ? search_params.created_at_to_hour
                    : ''
                }
                selected_minute={
                  search_params.created_at_to_minute.length > 0
                    ? search_params.created_at_to_minute
                    : ''
                }
                message={getMessage([
                  'created_at_to_ymd',
                  'created_at_to_hour',
                  'created_at_to_minute',
                ])}
                help_msg={''}
                customInput={<input type="text" className="search-form-input" />}
                handleChangeHour={(hour: string) =>
                  handleChangeSearchParams('created_at_to_hour', hour)
                }
                handleChangeMinute={(minute: string) =>
                  handleChangeSearchParams('created_at_to_minute', minute)
                }
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <span className="search-criteria-head">案件番号</span>
              <input
                type="text"
                className="search-form-input"
                name=""
                value={search_params.reception_cd}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeSearchParams('reception_cd', event?.target.value)
                }
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeSearchParams('reception_cd', inputAssistDigit(event?.target.value))
                }
              />
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-8 col-sm-16">
              <span className="search-criteria-head">ログレベル</span>
              <select
                name="ログレベル"
                className="search-form-input"
                value={search_params.error_level}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                  handleChangeSearchParams('error_level', event?.target.value)
                }
              >
                <option></option>
                {options?.error_level?.map((option, index) => {
                  return (
                    <option key={index} value={option.key}>
                      {option.value}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-md-3 col-sm-6">
              <span className="search-criteria-head">案件枝番号</span>
              <select
                name="案件枝番号"
                className="search-form-input"
                value={search_params.reception_sub_cd}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                  handleChangeSearchParams('reception_sub_cd', event?.target.value)
                }
              >
                <option></option>
                {options?.reception_sub_cd?.map((option, index) => {
                  return (
                    <option key={index} value={option.key}>
                      {option.value}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-8 col-sm-16">
              <span className="search-criteria-head">操作</span>
              <input
                type="text"
                className="search-form-input"
                name="操作"
                value={search_params.operation}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeSearchParams('operation', event?.target.value)
                }
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <span className="search-criteria-head">接続情報</span>
              <input
                type="text"
                className="search-form-input"
                name="接続情報"
                value={search_params.src_address}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeSearchParams('src_address', event?.target.value)
                }
              />
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-8 col-sm-16">
              <span className="search-criteria-head">メッセージID</span>
              <input
                type="text"
                className="search-form-input"
                name="メッセージID"
                value={search_params.message_code}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeSearchParams('message_code', event?.target.value)
                }
              />
            </div>
          </div>
          <div className="row my-2">
            <div className="col-md-10 col-sm-20">
              <span className="search-criteria-head">メッセージ</span>
              <input
                type="text"
                className="search-form-input-large"
                name="メッセージ"
                value={search_params.message}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeSearchParams('message', event?.target.value)
                }
              />
            </div>
            <div className="col-md-2 col-sm-4">
              <div className="search-btn">
                <button
                  className="btn btn-main-color"
                  disabled={false}
                  onClick={() => handleClickSearch()}
                >
                  検 索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogSearchForm;
